import React from 'react';

import RentalMeeting from '../../components/Prospecting/RentalMeeting';

function RentalMeetingView() {
  return (
    <RentalMeeting />
  );
}

export default RentalMeetingView; 